import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    staff: [],
    /* Paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,
    /* Filtro */
    nombre: '',
    documentoNumero: '',

    staffDatos: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_STAFF' (state) {
        state.staff = [];
        state.paginaActual = 1;
        state.registrosPorPagina = 10;
        state.totalRegistros = 0;
        state.totalPaginas = 0;
    },
    'SET_STAFF' (state, staff) {
        state.staff = staff;
    },
    'SET_PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },

    'INICIALIZAR_DATOS' (state) {
        state.staffDatos = [];
    },
    'SET_DATOS' (state, params) {
        state.staffDatos = params.staffDatos;
    },
};

const getters = {
    getField,
};

const actions = {
    getStaff ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_STAFF');

            let queryString = '?pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual;
            
            // if (state.nombre.trim() != '') {
            //     queryString += '&nombre=' + state.nombre.trim();
            // }

            // if (state.documentoNumero.trim() != '') {
            //     queryString += '&documentoNumero=' + state.documentoNumero.trim();
            // }

            apiAxios.get('staff' + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        var params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('SET_PAGINATION', params);
                    }
                    commit('SET_STAFF', res.data);

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },

    getDatos ( { commit }, staffId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_DATOS');

            if (staffId) {
                apiAxios.get('staff/' + staffId ) 
                    .then(res => {
                        let staffDatos = [
                            { 'nombre': 'nombreCompleto', 'campo': 'Apellido y Nombre', 'valor': res.data.nombreCompleto, 'formato': '' },
                            { 'nombre': 'documentoNumero', 'campo': 'Nro.Documento', 'valor': res.data.documentoNumero, 'formato': '' },
                            { 'nombre': 'numeroCelular', 'campo': 'Celular', 'valor': res.data.numeroCelular, 'formato': '' },
                            { 'nombre': 'email', 'campo': 'Email', 'valor': res.data.email, 'formato': '' },
                        ]
                
                        let params = {
                            staffDatos,
                        }
                                      
                        commit('SET_DATOS', params);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            }
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}